// extracted by mini-css-extract-plugin
export default {"pairContainer":"_OOMxOOMCzfSFLypezXU__pairContainer___","labelSizeSmall":"vrDfPYP9eusDj9fMKpkz__labelSizeSmall___","divider":"lomjaE_IdpkybjnoZulg__divider___"};